<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 mb-20  items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">New Expidition
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">Edit expidition
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6 pt-2">
          <div>
            <!-- ************************************************************************************ -->
            <!-- ************************************Select Colis***********************************-->
            <div class="px-6 mt-3">
              <div class="flex w-full space-x-2">
                <div class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                  <div class="flex w-full">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">person</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                        Package information
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full space-y-4">
                        

                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">From (Country of purchase)
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select @input="setSelected" v-model="formData.country" :options="options" label="name">
                                <template slot="option" slot-scope="option">
                                    <img class="flag-img" :src="$f.getCountryCode(option.code)"/>
                                    {{ option.name }} 
                                </template>
                            </v-select>
                          </p>
                        </div>
                       

                        <div class="flex">
                          <div class="border hover:border-green-500  w-full focus-within:border-blue-500 focus-within:text-green-500  transition-all duration-500 relative rounded p-1">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p><label for="Weight" class="bg-white text-gray-700 px-1">Weight <span class="text-green-500 ">*</span></label></p>
                              </div>
                              <div class="w-full rounded-md inline-flex">
                                <input id="customerFullName" autocomplete="false" tabindex="0" type="number" min="1" v-model="formData.weight"  class="py-2 text-xs px-2 outline-none block h-full w-full">
                                <div class="rounded-md w-1/12 bg-gray-200 text-center">Kg</div>
                              </div>
                            </div>
                         
                        </div>

                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerAddress" class="bg-white text-gray-700 px-1">Expedition Date
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                               <datetime-v2  v-model="formData.date" placeholder="Expedition date ..." input-class="py-2 text-xs px-2 outline-none block h-full w-full" ></datetime-v2> 
                          </p>
                        </div>

                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerShippingAddress" class="bg-white text-gray-700 px-1">Transport Mode
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <select id="type" name="seller" autocomplete="type" v-model="formData.transportMode"
                              class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                              <option selected disabled :value="null">Transport Mode</option>
                              <option v-for="(trans, index) in transports" :key="index" :value="trans">
                                {{ trans }}
                              </option>
                            </select>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ****************************** Order Information *********************************************-->

                <div class=" w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
                  <div class="flex w-full mt-2">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">home</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                       Warehouse
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full">
                        <div class="flex justify-center items-center">
                          <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="fill-current mr-2"><path  d="M12 6.453l9 8.375v9.172h-6v-6h-6v6h-6v-9.172l9-8.375zm12 5.695l-12-11.148-12 11.133 1.361 1.465 10.639-9.868 10.639 9.883 1.361-1.465z"></path></svg>
                          <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">To (warehouse country)
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select :disabled="formData._id?true:false" @input="setSelectedW" v-model="formData.warehouse" :options="warehouses" label="name">
                                <template slot="option" slot-scope="option">
                                    <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                                    {{ $f.getCountryNameByCode(options,option.country)}} 
                                </template>
                            </v-select>
                          </p>
                        </div>
                        </div>
                      
                        <span v-if="checkWarehousingParent.length>0" class="ware_prin">
                         
                          <div  class="border mll-4 hover:border-blue-400  w-10/12 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="customerPhone" class="bg-white text-gray-700 px-1">Zone (City)
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <v-select :disabled="formData._id?true:false" @input="setSelectedWParent" v-model="formData.warehouseParent" :options="checkWarehousingParent" label="name"></v-select>
                          </p>
                        </div>
                        </span >
                      </div>
                    </div>
                  </div>
                  <div class="flex w-full mt-2">
                    <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">local_grocery_store</i>
                    </span>

                    <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                        Carrier information
                      </div>
                      <div class="text-sm font-light text-gray-500"></div>
                      <div class="w-full space-y-4">
                        <div class="flex">
                          <div
                            class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                <label for="source" class="bg-white text-gray-700 px-1">Carrier name
                                  <span :class="$colors.required">*</span></label>
                              </p>
                            </div>
                            <p>
                              <input id="source" autocomplete="false" tabindex="0" type="text"
                                v-model="formData.carrier.name"
                                class="py-2 text-xs px-2 outline-none block h-full w-full" />
                            </p>
                          </div>
                        </div>

                        <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p>
                              <label for="sourceLink" class="bg-white text-gray-700 px-1">Carrier phone
                                <span :class="$colors.required">*</span></label>
                            </p>
                          </div>
                          <p>
                            <input id="sourceLink" autocomplete="false" tabindex="0" type="text"
                              v-model="formData.carrier.phone"
                              class="py-2 text-xs px-2 outline-none block h-full w-full" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Status and seller Administartion -->
              <div class="bg-white rounded-lg p-6" v-if="currentUser.type && currentUser.type != 'Seller'">
                  <div class="grid lg:grid-cols-2 gap-6">
                      <div  class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1"> Seller
                            <span :class="$colors.required">*</span></label>
                          </p>
                        </div>    
                        <p>
                            <v-select label="fullName" :disabled="formData && formData._id?true:false" @search="getUsersDebance($event,'shipsen')" v-model="formData.seller" :options="sellers"></v-select>
                        </p>
                        
                      </div>  
                      <!-- <div v-if="formData._id" class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1">Status
                            <span :class="$colors.required">*</span></label>
                          </p>
                        </div>
                        <p>
                           <select name="status" autocomplete="type" v-model="formData.status"
                                class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                                <option class="bg-white" selected :value="null">Status</option>
                                <option class="bg-white text-gray-600" v-for="(value, index) in status" :key="index" :value="value">
                                    {{ value }}
                                </option>
                            </select>
                        </p>
                      </div>  -->
                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="dateexpar" class="bg-white text-gray-700 px-1">Arrival date
                                      <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                              <input id="dateexpar"  type="date"  v-model="formData.arrivalDate" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                          </p>
                      </div>
                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="customerPhone" class="bg-white text-gray-700 px-1">Expedition fees 
                                      <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                              <input id="fees" autocomplete="false" tabindex="0" type="number" min="0" v-model="formData.fees" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                          </p>
                      </div>
                      <!-- <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="customerPhone" class="bg-white text-gray-700 px-1">Paid 
                                      <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                               <p class="flex items-center justify-center w-full">
                              
                                <label  for="toogleA" class="flex ml-5 items-center cursor-pointer">
                                  <div class="relative">
                                    <input id="toogleA" type="checkbox" class="hidden" v-model="formData.paid" />
                                    <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                    <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
                                  </div>
                                  
                                  <div class="ml-3 text-gray-700">{{ formData.paid  }}</div>
                                </label>
                              </p>
                      </div> -->
                  </div>  
              </div>     

              <!-- ********************************************************Product Table assigned to expedition **********************************-->
              <div class="flex w-full">
                <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg">
                  <div class="flex w-full justify-between items-center h-auto p-6">
                    <div class="flex w-full">
                      <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-blue-500">local_mall</i>
                      </span>
                      <div class="ml-3 w-full p-2 pb-8">
                        <div class="w-full flex text-base font-semibold text-gray-600">
                          <p class="w-1/2">Products</p>
                          <div class="w-full">
                            <button @click="OpenPopUp" :disabled="formData.seller===''"
                              class="flex text-white mx-auto max-w-sm rounded-md text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right">
                              Select Product
                            </button>
                          </div>
                        </div>


                        
                        <div class="mt-4 overflow-x-auto">
                          <table v-if="formData.details" class="min-w-full table item leading-normal">
                            <thead>
                              <tr>
                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  ID
                                </th>
                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Name
                                </th>

                               

                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Quantity
                                </th>

                                <th
                                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody v-for="(item, index) in formData.details" :key="index">
                              <tr>
                                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                  <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                    <b>{{ item.product.id }}</b>
                                  </div>
                                </td>
                                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                  <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900">
                                    {{ item.product.name }}
                                  </div>
                                </td>

                               

                                <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
                                  <div class="flex space-x-6">
                                    <button :class="$colors.textPrimary"
                                      class="bg-blue-500 rounded-md w-6 h-6 flex items-center focus:outline-none"
                                      @click="addQuantity(index)">
                                      <span class="font-bold text-2xl text-white">
                                        <i class="material-icons mt-2">add</i>
                                      </span>
                                    </button>

                                     <span :class="$colors.textPrimary" class="text-gray-700 text-sm h-6 flex items-center focus:outline-none">
                                         <input class="focus:outline-none w-12 text-center" type="text" v-model="item.quantity.sent">
                                     </span>

                                    <button :class="$colors.textPrimary" @click="removeQuantity(index)"
                                      class="bg-blue-500 rounded-md w-6 h-6 text-white flex items-center focus:outline-none">
                                      <span class="font-bold text-2xl text-white mt-1">
                                        <i class="material-icons">remove</i>
                                      </span>
                                    </button>
                                  </div>
                                  <div class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"></div>
                                </td>

                                <td class="py-4 whitespace-no-wrap border-b border-gray-200">
                                  <div class="flex justify-center">
                                    <button @click="removeProduct(item, index)" :class="$colors.actionTable"
                                      class="rounded-full flex focus:outline-none w-8 h-8 mr-3 mt-1">
                                      <i class="material-icons mx-1">delete</i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ************************************************************************************************-->
            </div>
            <!-- button save -->
            <div class="w-full">
              <div class="pt-3 flex btn-bottom-toolbar justify-end">
                <button
                  class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
                  @click="save">
                  Save
                </button>
              </div>
            </div>
            <!--end button save -->
            <!-- ***********************************Pop up Affectation products to Order************************************************ -->
             <vue-modal-2  name="Modal_products" :headerOptions="{title: 'Add Products'}" :noFooter="true" modalSize="lg" @on-close="closePopUp">
              <div class="flex p-5 pt-0  flex-col w-full h-auto mb-12">
                <!-- Header -->
                <div class="flex w-full h-auto justify-center items-center">
                  <div class="flex w-full h-auto  justify-center items-center text-2xl font-bold">
                    <span class="w-screen md:w-full h-10 cursor-pointer border border-gray-500 rounded text-sm flex">
                      <input type="search" name="search" v-model="searchText" placeholder="Search"
                        class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none" />
                      <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4">search</i>
                    </span>
                  </div>
                </div>
          
                  <div v-if="products.length <= 0" class="py-2">
                    <span class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base">
                      <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
                        <span class="">No Products found</span>
                      </p>
                    </span>
                  </div>
                  <table class="table table-report sm:mt-2 table-p">
                     <tr v-for="(item, index) in resultSearchUsers" :key="index" :value="item._id"  class="intro-x">
                      <td  class="w-10 border-b border-t border-l border-gray-500"><input   type="checkbox"  @change="addProductsToTemp(item, index)" v-model="item.check" class="form-checkbox order h-5 w-5 text-blue-500 border-gray-500"  /></td>
                      <td   class="w-10 border-b border-t border-gray-500"><div   class="flex"><div   class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden"><img   :alt="item.name" :src="item.picture||'https://img.icons8.com/external-others-inmotus-design/67/000000/external-Image-basic-ui-elements-others-inmotus-design-3.png'" ></div></div></td>
                      <td   class="border-b border-t border-r border-gray-500"><div  class="font-medium whitespace-nowrap">{{ item.name }}</div><div   class="text-gray-600 text-xs whitespace-nowrap mt-0.5">{{ exceptDes(item.description) }}</div></td>
                    </tr>
                  </table>
                  
           
              </div>

              <div class="modal-footer px-5 border0-t text-right">
                <button @click="closePopUp" :disabled="loading"
                  class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
                  Cancel
                </button>
                <button @click="ConfirmOperation" :disabled="loading"
                  class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right">
                  Confirm
                </button>
              </div>
            </vue-modal-2>
            <!-- ******************************************************** -->
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
    data() {
      return {
        formData: {
          weight: null,
          date: this.$moment(new Date()).format('yyyy-MM-DDTHH:mm'),
          arrivalDate:null,
          warehouseParent:null,
          carrier: {
            name: "",
            phone: "",
          },
          details: [],
          status: "expedited",
          country: "",
          warehouse:null,
          seller: "",
          quantity: {
            sent: 0,
          },
          transportMode: "",
        },
        paginate: {
          total: 0,
          currentpage: 1,
          lastpage: 1,
          per_page: 0,
        },
        searchText: "",
        products: [],
        warehouses:[],
        show_modal: true,
        productselected: [],
        numberItemRepeated: 0,
        sellers: [],
        status: ["expedited", "received","processed", "cancelled"],
        transports: ["road","railway","air", "maritime"],
        options:this.$countries,
        loading:false,
        checkWarehousingParent:[]
      };
    },
    async mounted() {
     // await this.getUser();
      await this.getCurrentSeller();

      //await this.getStatus();
      await this.dataToEdit();
     // await this.getWarehouses();
     // await this.getProducts({});
      this.dateMin();
    },
    methods: {
       RouterBack: function() {
       this.$router.back();
    },
      dateMin(){ 
          // document.getElementById('dateexp').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD'));
          // if(this.currentUser.type != "Seller")  document.getElementById('dateexpar').setAttribute('min', this.$moment(Date.now()).format('yyyy-MM-DD')); 
      },
      getUsersDebance: _.debounce(async function(name) {
          console.log('name----',name)
          if(this.formData.warehouse){
            await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.formData.warehouse._id||this.formData.warehouse,search:name}).then((res) => {
              this.sellers = res
            })
          }
      }, 500), 
       async getWarehouses(){
        const filter = {limit:1000};
        const res = await this.$server.search("warehouses",filter);
        if (res.content.results) {
             this.warehouses = res.content.results;
        } else this.warehouses = [];
      }, 
      exceptDes(text){
         if (text && text.length > 60) text = text.substring(0, 60) + "...";
       return text;
      },
      setSelected(contry) {
        if (contry) {
            this.formData.country = contry.name;
        } else {
            this.formData.country = "";
        }
      },
      async setSelectedW(warhouse){
          this.formData.details=this.checkWarehousingParent=[];
          this.formData.warehouseParent=null;
         if (warhouse) {
            this.formData.warehouse = warhouse;
            const resW = await this.$server.search("warehouses", { country: warhouse.country,all:true,limit:100}); 
            console.log('resW--------',resW)
            if(resW.content && resW.content.results) {
                this.checkWarehousingParent=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
            }else this.checkWarehousingParent=[];
            if (this.currentUser.type != "Seller"){
                this.formData.seller=null;
                await this.getSellers(warhouse._id||warhouse)
            }  
         }else this.formData.warehouse = null;
      },
      setSelectedWParent(){

      },
      setStatusSelected(status) {
        if (status) {
          this.formData.status = status;
        } else {
          this.formData.status = "";
        }
      },

      async getCurrentSeller() {
          this.warehouses = this.currentUser.warehouses;
          if (this.currentUser.type == "Seller") this.formData.seller = this.currentUser._id;
      },
     async getSellers(warehouse) {
      const filter = {
        type: "Seller",
        warehouses:warehouse,
        limit:10
      };
      const res = await this.$server.search("users", filter);
      if (res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    },
      async getUser() {
        const res = await this.$server.me("users");
        console.log(res);
        if (res.content) this.currentUser = res.content;
        else this.currentUser = {};
      },
      async getProducts(filters) {
        if(this.formData.warehouse){
            if(this.formData.seller) filters.seller = this.formData.seller._id;
            filters.limit=3000;
            filters['details.warehouse']=this.formData.warehouse._id||this.formData.warehouse;
            const res = await this.$server.search("products", filters);
            if (res.content.results) {
              this.products = res.content.results;
              this.paginate.total = res.content.total;
              this.paginate.lastpage = res.content.last_page;
              this.paginate.per_page = res.content.per_page;
              this.paginate.currentpage = res.content.current_page;

              for (let i in this.products) {
                this.products[i].quantity = this.products[i].quantity.inStock;
              // this.products[i].check = false;
                /*if (this.products[i].category)
                  this.products[i].category = this.products[i].category.name;*/
                if (this.products[i].seller)
                  this.products[i].seller = this.products[i].seller.username;
              }
            } else this.products = [];
        }
  
      },
      async save() {
        if (this.formData._id) {
           if (this.formData.status=='received' && (!this.formData.arrivalDate || !this.formData.fees)){
                let mess="Arrival Date required !!";
                if(!this.formData.fees) mess="Expedition Fees !!";
                alert(mess, "warning");
                return false
            }
          if(this.checkWarehousingParent.length>0 && this.formData.warehouse && !this.formData.warehouseParent){
             this.loading=false;
             alert("Zone required !", "warning");
             return false;
          }
          this.loading=true;
          this.formData.checkWarehousingParent=this.checkWarehousingParent;
          const data = await this.$server.update("expeditions", this.formData);
          this.loading=false;
          if(data && data._id) {
             alert("Expedition updated", "success");
             await this.dataToEdit();
          }
        } else {
          console.log('this.formData---',this.formData);
          this.formData.weight=parseFloat(this.formData.weight);
          if(this.checkWarehousingParent.length>0 && this.formData.warehouse && !this.formData.warehouseParent){
            this.loading=false;
            alert("Zone required !", "warning");
            return false;
          }

          if (this.checkData()) {
            this.formData.country_to="Burkina Faso";
            if (location.hostname == 'app.shipsen.com' || location.hostname == 'ivorycoast.shipsen.com') this.formData.country_to="Côte d'Ivoire";
            if (location.hostname == 'senegal.shipsen.com') this.formData.country_to="Sénégal";
            this.loading=true;
            this.formData.checkWarehousingParent=this.checkWarehousingParent;
            const data = await this.$server.create("expeditions", this.formData);
            this.loading=false;
            if (data && data._id) {
              this.formData = {
                carrier: {},
                details: [],
                warehouseParent:null,
                date: this.$moment(new Date()).format('yyyy-MM-DDTHH:mm'),
              };
              this.checkWarehousingParent=[];
              if(this.currentUser.type == "Seller") this.formData.seller = this.currentUser._id;
               alert("Expedition created !", "success");
            }else  alert(data, "warning");
          } else alert(`you must fill all the fields !! `, "warning");
        }
      },
      getQuantity() {
        this.formData.quantity.sent = 0;
        for (let i = 0; i < this.formData.details.length; i++) {
          this.formData.quantity.sent += this.formData.details[i].quantity;
        }
      },
      checkData() {
        if (
          this.formData.weight &&
          this.formData.country &&
          this.formData.transportMode &&
          this.formData.date &&
          this.formData.details.length > 0 &&
          this.formData.carrier &&
          this.formData.carrier.name &&
          this.formData.carrier.phone &&
          this.formData.seller &&
          this.formData.warehouse
        )
          return true;
        else return false;
      },
      removeProduct(data, index) {
        this.$confirm("Are you sure you want to delete this product?").then(
          async (res) => {
            let pos = this.formData.details
              .map(function (e) {
                return e.product._id;
              })
              .indexOf(data._id);

            this.formData.details.splice(pos, 1);
            data.product.check = false;
            alert(`Product deleted !`, "success");
          }
        );
      },

      addProductsToTemp(data, index) {
        if (data.check) {
          const detail = {
            product: data,
            quantity: {
              sent: 1,
            },
          };

          let found = 0;
          for (let i = 0; i < this.formData.details.length; i++) {
            if (this.formData.details[i].product._id == data._id) {
              found = found + 1;
              this.numberItemRepeated = this.numberItemRepeated + 1;
            }
          }
          if (found >= 1) {
          } else {
            this.productselected.push(detail);
          }
        } else {
          let pos = this.productselected
            .map(function (e) {
              return e.product._id;
            })
            .indexOf(data._id);
          this.productselected.splice(pos, 1);
        }
      },

      addQuantity(index) {
        this.formData.details[index].quantity.sent++;
      },
      removeQuantity(index) {
        if (this.formData.details[index].quantity.sent <= 1) {
        } else {
          this.formData.details[index].quantity.sent--;
        }
      },
      ViderTable() {
        this.productselected = [];
      },
       ViderProductTable() {
       this.formData.details= [];
       },
     async OpenPopUp() {
         if (this.formData.seller) {
            await this.getProducts({});
             if (this.products.length > 0) {
                   this.$vm2.open("Modal_products");
             }else{
                 if(this.currentUser.type != 'Seller') alert(`There are no products for the selected seller`, "warning");
                 else{
                  if(!this.formData.warehouse) alert('Please select warehouse !', "warning");
                  else alert(`You haven't added any product yet`, "warning");  
                }
             }
         }
      },
      ConfirmOperation() {
        let fount = 0;
        if (this.numberItemRepeated > 0) {
          alert(`There are many products already added!`, "success");
        } else {
          for (let i = 0; i < this.productselected.length; i++) {
            this.formData.details.push(this.productselected[i]);
          }
        }
        this.productselected = [];

        this.numberItemRepeated = 0;
         this.$vm2.close("Modal_products");
      },
      closePopUp() {
         this.$vm2.close("Modal_products");
      },
      async dataToEdit() {
        if (this.$route.params.id) {
          const editData = await this.$server.get("expeditions", {
            id: this.$route.params.id,
          });
          this.formData = editData.content;
          this.formData.date = this.$moment(this.formData.date).format('yyyy-MM-DDTHH:mm');
          if(this.formData.arrivalDate)   this.formData.arrivalDate = this.$moment(this.formData.arrivalDate).format('yyyy-MM-DDTHH:mm');
          if(this.formData.details[0].warehouseParent) {
            this.formData.warehouseParent={_id:this.formData.details[0].warehouseParent,name:this.formData.details[0].warehouseParentName};
            this.checkWarehousingParent=[{_id:this.formData.details[0].warehouseParent,name:this.formData.details[0].warehouseParentName}];
          }
        }
      },
    },

    computed: {
      resultSearchUsers() {
        if (this.searchText) {
          return this.products.filter((product) => {
            var regex = new RegExp(this.searchText, "i");

            return regex.test(product.name);
          });
        } else {
          return this.products;
        }
      },
    },

    /************************************* Pagination **************************************************/
  };
</script>

<style scoped>
.vs__dropdown-toggle {
    border: none;
}  
  .modal-header {
    background: #226faa;
    background: -webkit-gradient(linear,
        left top,
        right top,
        from(#226faa),
        color-stop(37%, #2989d8),
        to(#72c0d3));
    background: linear-gradient(to right, #226faa 0, #2989d8 37%, #72c0d3 100%);
    border-radius: 6px;
    color: #fff;
    padding: 18px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-color: transparent;
    border-bottom: 1px solid #e5e5e5;
  }

  .table.item thead {
    background: #3182ce4f;
    color: #fff;
    border: 0;
  }

  .toggle__dot {
    transition: all 0.3s ease-in-out;
  }

  .seller-select .vs__dropdown-toggle {
    border: none;
  }

  input:checked~.toggle__dot {
    transform: translateX(100%);
    background-color: #68d391;
  }

  /* animation for vue transition tag */
  dialog[open] {
    animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
  }

  dialog::backdrop {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
    backdrop-filter: blur(3px);
  }

  @keyframes appear {
    from {
      opacity: 0;
      transform: translateX(-3rem);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  
  .toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
</style>
